<template>
    <v-col>
        <m-form ref="form">
            <v-row>
                <v-col class="div_numero_cartao">
                    <m-text-field
                            id="FieldNumeroCartao"
                            v-mask="bandeiraObject.mask"
                            outlined
                            label="Número do Cartão:"
                            class="required"
                            :rules="[ruleSelecionarBandeira, $rules.required, ruleNumeroCartaoLength]"
                            validate-on-blur
                            @focus="flipped = false"
                            :maxlength="maxLengthBandeira"
                            v-model="numero_cartao" />
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="$slots.default ? 8 : 12">
                    <m-text-field
                            id="NomeCartao"
                            outlined
                            label="Nome impresso no cartão:"
                            class="required"
                            maxlength="80"
                            v-uppercase
                            v-input-filter="[$filters.text]"
                            :rules="[$rules.required, ruleNomeCartaoLength]"
                            @focus="flipped = false"
                            v-model="nome_cliente" />
                </v-col>
                <v-col :cols="$slots.default ? 4 : 6">
                    <m-text-field
                            id="FieldDataValidade"
                            outlined
                            label="Data Validade:"
                            class="required"
                            v-mask="'##/##'"
                            :rules="[$rules.required, ruleValidade]"
                            @focus="flipped = false"
                            v-model="expiracao" />
                </v-col>
                <v-col :cols="$slots.default ? 4 : 6">
                    <div class="cvv_label">
                        <m-text-field
                                id="FieldVerificador"
                                outlined
                                label="CVV:"
                                class="required"
                                @focus="flipped = true"
                                v-mask="['###','####']"
                                :rules="[$rules.required, ruleCvvLength]"
                                v-model="cvv"
                                :maxlength="maxLengthCVV" />
                        <label>Últimos {{ maxLengthCVV }} números do verso do Cartão</label>
                    </div>
                </v-col>
                <v-col v-if="$slots.default">
                    <slot />
                </v-col>
            </v-row>
        </m-form>

        <v-flex class="scene">
            <div class="card" :class="{'is-flipped': flipped}" @click="flipped = !flipped">
                <div class="card__face card__face--front" :style="cardStyle">
                    <img class="chip" src="../../../assets/img/chip.png" alt="Chip do Cartão" />
                    <img class="bandeira" :src="bandeiraObject.icon" :alt="bandeiraObject.text" />
                    <p class="numero_cartao">{{ numero_cartao }}</p>
                    <p class="nome_cliente">{{ nome_cliente.toUpperCase() }}</p>
                    <p class="data_validade_label">data<br />válida</p>
                    <p class="data_validade">{{ expiracao }}</p>
                </div>
                <div class="card__face card__face--back pa-2 pt-5" :style="cardStyle">
                    <div class="fita_preta" />
                    <div class="ccv">{{ cvv }}</div>
                </div>
            </div>
        </v-flex>
    </v-col>
</template>

<script>
  import { mapStateless } from '@/plugins/helpers'
  import moment from 'moment'

  export default {
    name: 'FormaCartao',
    props: { value: Object, bandeirasBase: Array },
    data: () => ({
      flipped: false
    }),
    computed: {
      ...mapStateless([
        'numero_cartao',
        'nome_cliente',
        'expiracao',
        'bandeira',
        'cvv'
      ]),
      bandeiras () {
        let bandeiras_permitidas = [{ text: '', codigo: '0', mask: '#### #### #### ####' }]
        this.bandeirasBase.forEach((band) => {
          let cor_bandeira = null

          switch (band.nome_bandeira.toUpperCase()) {
            case 'VISA':
              cor_bandeira = '#64B5F6AA'
              break
            case 'MASTERCARD':
              cor_bandeira = '#ff0d20C4'
              break
            case 'ELO':
              cor_bandeira = '#212121AA'
              break
            case 'AMEX':
              cor_bandeira = '#0D47A1AA'
              break
            case 'DINERS CLUB':
              cor_bandeira = '#0D47A1AA'
              break
            case 'DISCOVER':
              cor_bandeira = '#0D47A1AA'
              break
            case 'JCB':
              cor_bandeira = '#0D47A1AA'
              break
            case 'AURA':
              cor_bandeira = '#2C328CAA'
              break
            case 'CABAL':
              cor_bandeira = '#006398AA'
              break
            case 'BANESCARD':
              cor_bandeira = '#B8DA37AA'
              break
            case 'HIPERCARD':
              cor_bandeira = '#B3131BAA'
              break
          }

          bandeiras_permitidas.push({ text: band.nome_bandeira.toUpperCase(), codigo: band.codigo_bandeira, mask: band.mascara_bandeira, icon: require('../../../assets/img/cartao_' + band.nome_bandeira.toLowerCase() + '.png'), cor: cor_bandeira })
        })

        return bandeiras_permitidas
      },
      bandeiraObject () {
        return this.bandeiras.find(b => b.text === this.bandeira) || { mask: '#### #### #### ####' }
      },
      cardStyle () {
        const bandeira = this.bandeiraObject
        return { backgroundColor: bandeira.cor || 'gray' }
      },
      maxLengthBandeira () {
        return 25
      },
      maxLengthCVV () {
        return this.bandeira === 'DISCOVER' || this.bandeira === 'AMEX' ? 4 : 3
      },
      ruleSelecionarBandeira () {
        return () => !!this.bandeira || 'Selecione a bandeira do cartão'
      },
      ruleNumeroCartaoLength () {
        if (this.bandeira === 'DINERS CLUB' && this.numero_cartao.length === 16) {
          return true
        } else if (this.bandeira === 'AMEX' && this.numero_cartao.length === 17) {
          return true
        } else if (this.bandeira !== 'DINERS CLUB' && this.bandeira !== 'AMEX' && this.numero_cartao.length === 19 && this.bandeira !== '') {
          return true
        } else {
          return 'Número do cartão inválido'
        }
      },
      ruleCvvLength () {
        return () => (this.cvv || '').length >= 3 || 'CVV inválido'
      },
      ruleNomeCartaoLength () {
        return () => (this.nome_cliente || '').length >= 3 || 'Nome impresso no cartão inválido'
      },
      ruleValidade () {
        return (value) => {
          if ((value || '').length === 5) {
            const data_expiracao = moment(value, 'MM/YY', true)
            const now = moment().startOf('month')

            if (data_expiracao.isValid()) {
              if (data_expiracao.isSameOrAfter(now)) {
                return true
              }
              return 'Data expirada'
            }
          }
          return 'Data inválida'
        }
      }
    },
    watch: {
      numero_cartao (val) {
        let trimVal = val.replace(/\s/g, '')
        if (trimVal.length > 6) {
          trimVal = trimVal.substring(0, 6)
        }

        const visa_patterns = [
          4
        ]

        const master_patterns = [
          5,
          [
            51,
            55
          ],
          [
            2221,
            2720
          ]
        ]

        const elo_patterns = [
          401178,
          401179,
          431274,
          438935,
          451416,
          457393,
          457631,
          457632,
          504175,
          627780,
          636297,
          636297,
          636368,
          [
            506699,
            506778
          ],
          [
            509000,
            509999
          ],
          [
            650031,
            650033
          ],
          [
            650035,
            650051
          ],
          [
            650405,
            650439
          ],
          [
            650485,
            650538
          ],
          [
            650541,
            650598
          ],
          [
            650700,
            650718
          ],
          [
            650720,
            650727
          ],
          [
            650901,
            650920
          ],
          [
            651652,
            651679
          ],
          [
            655000,
            655019
          ],
          [
            655021,
            655058
          ],
          [
            650921,
            650978
          ]
        ]
        const american_patterns = [
          34,
          37
        ]
        const diners_patterns = [
          36,
          309,
          [
            300,
            305
          ],
          [
            38,
            39
          ]
        ]
        const discover_patterns = [6011, 622, 64, 65]
        const jcb_patterns = [35]

        const aura_patterns = [50]

        const hiper_patterns = [637095, 637612, 637599, 637609, 637568, 606282]

        let is_visa = false
        let is_master = false
        let is_elo = false
        let is_american = false
        let is_diners = false
        let is_discover = false
        let is_jcb = false
        let is_aura = false
        let is_hipercard = false
        let is_cabal = false
        let is_banescard = false

        visa_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = true
            is_master = false
            is_elo = false
            is_american = false
            is_diners = false
            is_discover = false
            is_jcb = false
            is_aura = false
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'VISA' // VISA
          }
        })

        master_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = true
            is_elo = false
            is_american = false
            is_diners = false
            is_discover = false
            is_jcb = false
            is_aura = false
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'MASTERCARD' // MASTERCARD
          }
        })

        elo_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = false
            is_elo = true
            is_american = false
            is_diners = false
            is_discover = false
            is_jcb = false
            is_aura = false
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'ELO' // ELO
          }
        })

        american_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = false
            is_elo = false
            is_american = true
            is_diners = false
            is_discover = false
            is_jcb = false
            is_aura = false
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'AMEX' // AMERICAN
          }
        })

        diners_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = false
            is_elo = false
            is_american = false
            is_diners = true
            is_discover = false
            is_jcb = false
            is_aura = false
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'DINERS' // DINERS
          }
        })

        discover_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = false
            is_elo = false
            is_american = false
            is_diners = false
            is_discover = true
            is_jcb = false
            is_aura = false
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'DISCOVER' // DISCOVER
          }
        })

        jcb_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = false
            is_elo = false
            is_american = false
            is_diners = false
            is_discover = false
            is_jcb = true
            is_aura = false
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'JCB' // JCB
          }
        })

        aura_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = false
            is_elo = false
            is_american = false
            is_diners = false
            is_discover = false
            is_jcb = false
            is_aura = true
            is_hipercard = false
            is_cabal = false
            is_banescard = false

            this.bandeira = 'AURA' // AURA
          }
        })

        hiper_patterns.forEach(pattern => {
          if (this.validate_cartao_numero(pattern, trimVal)) {
            is_visa = false
            is_master = false
            is_elo = false
            is_american = false
            is_diners = false
            is_discover = false
            is_jcb = false
            is_aura = false
            is_hipercard = true
            is_cabal = false
            is_banescard = false

            this.bandeira = 'HIPERCARD' // HIPERCARD
          }
        })

        if ((!is_visa && !is_master && !is_elo && !is_american && !is_diners && !is_discover && !is_jcb && !is_aura && !is_hipercard && !is_cabal && !is_banescard) || trimVal === '') {
          this.bandeira = '' // NULL
        }
      }
    },
    methods: {
      validate () {
        return this.$refs.form.validate()
      },
      validate_cartao_numero (pattern, val) {
        /** Em resumo, essa função previne a comparação de 2 numeros
         * cuja a quantidade de casas decimais sejam diferentes, por exemplo:
         *
         * (pattern = 55, val = 847565) => a comparação fica {
         *  return 55 === 84
         * }
         *
         * No caso de um array a quantidade de casas decimais é igual a do
         * segundo item.
        */

        if (pattern instanceof Array) {
          let pattern_len = pattern[1].toString().length
          let _val = val.substring(0, pattern_len)

          return parseInt(_val) >= pattern[0] && parseInt(_val) <= pattern[1]
        } else {
          let pattern_len = pattern.toString().length
          let _val = val.substring(0, pattern_len)

          return parseInt(_val) === pattern
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .bandeira-icon {
        margin: auto !important;
        display: block;
    }

    .text-bandeira {
        margin-top: 3px;
    }

    .scene {
        width: 400px;
        height: 250px;
        perspective: 600px;
        margin: auto;
    }

    .card {
        width: 100%;
        height: 100%;
        cursor: pointer;
        transform-style: preserve-3d;
        transform-origin: right center;
        transition: transform 1s;
    }

    .card.is-flipped {
        transform: translateX(-100%) rotateY(-180deg);
    }

    .card__face {
        font-family: Consolas, Courier, monospace !important;
        position: absolute;
        width: 100%;
        height: 100%;
        color: whitesmoke;
        border-radius: 10px;
        backface-visibility: hidden;
    }

    .card__face--back {
        padding: 0 !important;
        border-radius: 10px;
        background: gray;
        transform: rotateY(180deg);
    }

    .chip {
        position: absolute;
        top: 50px;
        left: 30px;
        height: 48px;
    }

    .bandeira {
        position: absolute;
        top: 50px;
        right: 30px;
        height: 48px;
    }

    .numero_cartao {
        position: absolute;
        top: 48%;
        width: 100%;
        font-size: 30px;
        text-align: center;
        letter-spacing: 1px;
    }

    .nome_cliente {
        position: absolute;
        top: 190px;
        left: 30px;
        font-size: 18px;
        width: 220px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .data_validade_label {
        position: absolute;
        top: 195px;
        right: 100px;
        font-size: 11px;
        text-align: right;
        line-height: 10px;
    }

    .data_validade {
        position: absolute;
        top: 190px;
        right: 40px;
        font-size: 18px;
    }

    .fita_preta {
        margin-top: 20px;
        height: 50px;
        background-color: black;
    }

    .ccv {
        border-radius: 2px;
        text-align: right;
        padding: 8px;
        margin: 20px auto;
        min-height: 36px;
        width: 90%;
        letter-spacing: 1px;
        color: #000;
        font-size: 1rem;
        background: repeating-linear-gradient(45deg, #ededed, #ededed 5px, #f9f9f9 5px, #f9f9f9 10px);
    }

    .cvv_label {
        margin-bottom: 25px;
        margin-top: 25px;
    }
</style>
